module.exports = __webpack_public_path__ + "static/aggregation180-b8e7112b84282911e58e12ccaa8f3501.png";